// This file is generated by the Webpack next-flight-loader.
import { registerClientReference } from "react-server-dom-webpack/server";
export const TableIndeterminateCheckbox = registerClientReference(
function() { throw new Error("Attempted to call TableIndeterminateCheckbox() from the server but TableIndeterminateCheckbox is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
"/app/shared/ui/TableIndeterminateCheckbox/TableIndeterminateCheckbox.tsx",
"TableIndeterminateCheckbox",
);